import { queryOptions } from '@tanstack/react-query';

import { ONE_HOUR } from '@/constants/time';
import { paths } from '@/types/api';
import { fetchClient } from '@/util/fetchClient';

type GetContentLibraryItemLikeStatusV2Params =
  paths['/v2/content-library-items/{contentLibraryItemId}/like-status']['get']['parameters']['path'];

export type GetContentLibraryItemLikeStatusV2Response =
  paths['/v2/content-library-items/{contentLibraryItemId}/like-status']['get']['responses'][200]['content']['application/json']['data'];

export async function getContentLibraryItemLikeStatusV2({
  contentLibraryItemId,
}: GetContentLibraryItemLikeStatusV2Params): Promise<GetContentLibraryItemLikeStatusV2Response> {
  const { data } = await fetchClient.GET(
    '/v2/content-library-items/{contentLibraryItemId}/like-status',
    {
      params: { path: { contentLibraryItemId } },
    }
  );

  return data?.data;
}

export function getContentLibraryItemV2QueryLikeStatusOptions(
  userId: string | undefined,
  params: GetContentLibraryItemLikeStatusV2Params
) {
  return queryOptions({
    queryKey: ['contentLibraryItemLikeStatusV2', userId, params.contentLibraryItemId],
    queryFn: () => getContentLibraryItemLikeStatusV2(params),
    staleTime: ONE_HOUR,
    gcTime: ONE_HOUR,
  });
}
